var activeSlug;
var isScrolling = false, // gdy strona się scrolluje to zmienna ma wartość true i nie wysyłamy statów na hover np. akordeon, hotpoint
	lastReportedSlug = null;
var wp_content_selector;

(function () {
	if (
		!document.getElementsByClassName('__js_section').length ||
		document.location.href.indexOf('.html') > 0
	) return;

	var $sections = $('.__js_section'),
		initSlug =
			document.location.pathname.split('/').pop() ||
			$('.__js_section').eq(0).attr('id');

	activeSlug = initSlug;

	// jeśli chcesz obniżyć o sticky nagłówek z tłem, podstaw jego wysokość, np. $('.header').outerHeight() || 0
	var customOffset = 0;
	var animationTime = 1000;

	// przewinięcie do sekcji na starcie (jeśli w URL jest slug)
	var scrollOnStart = function () {
		var $target = $('#' + initSlug);
		if ($target.length) {
			$('html,body').animate(
				{ scrollTop: Math.max(0, $target.offset().top - customOffset) },
				animationTime,
				'easeOutExpo'
			);
		}

		sendStats('progress', 'start', initSlug);

		changeActiveSlug(initSlug);
		initNavigation();
	};

	// staty pageviews i scrollboost pwp
	var reportSlugTS = -1;
	var reportSlug = function () {
		if (lastReportedSlug === null) {
			// pageview standard
			wp_dot_addparams.ctags = statData[activeSlug].tags;

			(window.dataLayer = window.dataLayer || []).push({
				event: 'pageview',
				page: {
					pageviewType: 'standard',
					error404: basicStatData.ga.page.error404,
					templateType: 'AS',
				},
				site: {
					name: basicStatData.ga.site.name,
					version: basicStatData.ga.site.version,
					cms: basicStatData.ga.site.cms,
					as: { orderId: asorderid, productName: asproduct, name: asname },
				},
				content: {
					title: statData[activeSlug].title,
					category: {
						IAB: statData[activeSlug].category.IAB,
						Gemius: statData[activeSlug].category.Gemius,
					},
					tags: statData[activeSlug].tags,
				},
			});

		} else {
			// pageview scrollboost
			wp_content_selector = document.getElementById(lastReportedSlug);

			WP.push(function () {
				WP.stat.show(
					wp_sn,
					{ category: 'pageviewVpv', label: 'scrollboost', asproduct, asorderid, asname }
				);
			});

			unloadData(lastReportedSlug);
			wp_dot_addparams.ctags = statData[activeSlug].tags;

			(window.dataLayer = window.dataLayer || []).push({
				event: 'pageviewVpv',
				page: {
					pageviewType: 'scrollboost',
					error404: basicStatData.ga.page.error404,
					templateType: 'AS',
				},
				site: {
					name: basicStatData.ga.site.name,
					version: basicStatData.ga.site.version,
					cms: basicStatData.ga.site.cms,
					as: { orderId: asorderid, productName: asproduct, name: asname },
					frontendPlatform: 'other',
				},
				content: {
					title: statData[activeSlug].title,
					category: {
						IAB: statData[activeSlug].category.IAB,
						Gemius: statData[activeSlug].category.Gemius,
					},
					tags: statData[activeSlug].tags,
				}
			});
		}

		lastReportedSlug = activeSlug;
		reportSlugTS = -1;
	};

	var changeActiveSlug = function (slug) {
		activeSlug = slug;

		$('.header__nav [data-slug]').parents('.item').removeClass('__active');
		$('.header__nav [data-slug]').removeClass('__active');
		$('.header__nav [data-slug=' + activeSlug + ']').parents('.item').addClass('__active');
		$('.header__nav [data-slug=' + activeSlug + ']').addClass('__active');

		if (document.location.search.length > 0) {
			history.pushState({ id: slug }, $(this).attr('title'), slug + document.location.search);
		} else {
			history.pushState({ id: slug }, $(this).attr('title'), slug);
		}

		var subtitle = statData[activeSlug].title ? statData[activeSlug].title + ' - ' : '';

		if (document.querySelector('title') && statData[activeSlug]) {
			document.querySelector('title').innerText = subtitle + defaultSiteTitle;
		}
		if (document.querySelector('meta[property="og:title"]') && statData[activeSlug]) {
			document.querySelector('meta[property="og:title"]').content = subtitle + defaultSiteTitle;
		}
		if (document.querySelector('meta[name="twitter:title"]') && statData[activeSlug]) {
			document.querySelector('meta[name="twitter:title"]').content = subtitle + defaultSiteTitle;
		}

		if (lastReportedSlug === null) {
			reportSlug(); // pierwsze wejście
		} else if (lastReportedSlug != slug) {
			if (reportSlugTS > -1) clearTimeout(reportSlugTS);
			reportSlugTS = setTimeout(reportSlug, 1000);
		} else {
			if (reportSlugTS > -1) clearTimeout(reportSlugTS);
		}
	};

	// indeks aktywnego sluga
	var getActiveSlugIndex = function (slug) {
		if (!slug) slug = activeSlug;
		return $('.header__nav [data-slug=' + slug + ']').parent().parent().index();
	};

	// aktywna sekcja pod nagłówkiem
	// bierzemy ostatnią sekcję, której offsetTop <= offsetLine
	var sectionScrollCheckTS = null;
	var sectionScrollCheck = function () {
		sectionScrollCheckTS = setTimeout(sectionScrollCheck, 200);

		var $W = $(window),
			topScroll = $W.scrollTop(),
			wHeight = $W.height();

		// wysokość dokumentu
		var docHeight = Math.max(
			document.body.scrollHeight, document.documentElement.scrollHeight,
			document.body.offsetHeight, document.documentElement.offsetHeight,
			document.body.clientHeight, document.documentElement.clientHeight
		);

		// linia referencyjna: tuż pod nagłówkiem (dodajemy niewielką tolerancję)
		var scrollMargin = 4; // px
		var offsetLine = topScroll + customOffset + scrollMargin;

		// wymuszenie strony głównej
		if (
			topScroll <= customOffset &&
			document.location.pathname.split('/').pop().length < 1
		) {
			changeActiveSlug($sections.eq(0).attr('id'));
			return;
		}

		// jeśli jesteśmy przy samym dole strony, oznacz ostatnią sekcję
		if (topScroll + wHeight >= docHeight - scrollMargin) {
			var lastId = $sections.last().attr('id');
			if (lastId && lastId !== activeSlug) changeActiveSlug(lastId);
			return;
		}

		// standard: znajdź ostatnią sekcję, której top <= offsetLine
		var pickedId = null;
		for (var i = 0; i < $sections.length; i++) {
			var $section = $sections.eq(i),
				sectionOffset = $section.offset().top;

			if (sectionOffset <= offsetLine) {
				pickedId = $section.attr('id');
			} else {
				break; // kolejne sekcje będą tylko niżej
			}
		}

		if (!pickedId) pickedId = $sections.eq(0).attr('id');

		if (pickedId && pickedId !== activeSlug) {
			changeActiveSlug(pickedId);
		}
	};

	// inicjalizacja obsługi nawigacji
	var initNavigation = function () {
		sectionScrollCheckTS = setTimeout(sectionScrollCheck, animationTime + 25);

		$('.header__nav [data-slug]').on('click', function (e) {
			isScrolling = true;
			if (sectionScrollCheckTS) clearTimeout(sectionScrollCheckTS);

			e.preventDefault();
			var $this = $(this),
				slug = $this.data('slug');

			if (!slug || !slug.length) slug = '/';

			var eventAction = ("ontouchstart" in document.documentElement) ? "tap" : "click";
			(window.dataLayer = window.dataLayer || []).push(
				{ event: 'site_interaction', category: 'nav_link', action: eventAction, label: slug }
			);

			changeActiveSlug(slug);

			var $target = $('#' + slug);
			var targetTop = $target.length
				? Math.max(0, $target.offset().top - customOffset + 10)
				: 0;

			$('html,body').animate(
				{ scrollTop: targetTop },
				animationTime,
				'easeInOutExpo',
				function () { isScrolling = false; }
			);

			sectionScrollCheckTS = setTimeout(sectionScrollCheck, animationTime + 25);
		});
	};

	if (initSlug && initSlug.length > 1) {
		setTimeout(scrollOnStart, 800);
	} else {
		initNavigation();
	}
})();